import React from 'react';
import './App.css';
import '@adyen/adyen-web/dist/adyen.css';
import {Routes, Route, BrowserRouter} from "react-router-dom";
import {Select} from "./features/select/Select";
import {PaymentContainer} from "./features/payment/Payment";
import {RedirectContainer} from "./features/redirect/Redirect";
import {StatusContainer} from "./features/status/Status";
import { Home } from './features/home/Home';
import "./services/i18n";
import UrlComponent from "./components/UrlComponent";
function App() {
  return (
    <BrowserRouter>
      <UrlComponent/>
      <div className="container">
        <Routes>
          <Route path={"/select"} element={<Select />} />
          <Route path={"/status/:type"} element={<StatusContainer />} />
          <Route path={"/redirect"} element={<RedirectContainer />} />
          <Route path={"/payment/:type"} element={<PaymentContainer />} />
          <Route path={"/payment/"} element={<PaymentContainer />} />
          <Route path={"/"} element={<Home />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
